import React from "react";
import { Table } from "antd";
import CircleIIcon from "../../../assets/circle_i.svg";
import { removeAccountPrefixFromLabels } from "../../../../src/global/utility/Utils";
import ATSToolTip from "../../../global/components/ATSToolTip";

function ShipmentCloneLocations({locations}) {
  let tableLocationData = [];
  var value= locations
  {
    value?.map((item, index) => (
      tableLocationData.push({
        locationtype: item,
        name: item?.name,
        address: item?.address,
        latitude: item?.latitude,
        longitude: item?.longitude,
        radius: item?.radius,
        alerttype: item?.alerttype && item?.alerttype !== null ? item.alerttype.charAt(0).toUpperCase() + item.alerttype.slice(1) : "Notification",
        trigger: item?.trigger || "None",
        alertgroup: Array.isArray(item?.alertgroup) && item.alertgroup.length > 0
          ? removeAccountPrefixFromLabels(item.alertgroup).join(", ")
          : (item?.alertgroup ?? "").toString().trim().length > 0
            ? removeAccountPrefixFromLabels([item.alertgroup]).join(", ")
            : "None"
      })
    ))
  }
    const locationcolumns = [
      {
      title: (<span className="font-face-vzw">Shipping</span>),
        dataIndex: "locationtype",
        key: "locationtype",
        width: 70,
        onHeaderCell: () => ({
          "data-tooltip": "",
        }),
        render: (text) => {
          return (
            <div className="d-flex flex-row justify-content-start align-items-center">
              <div>{text?.locationtype}<br/>({text?.name})</div>
            </div>
          );
        },
      },
      {
      title: (<span className="font-face-vzw">Address</span>),
        dataIndex: "address",
        key: "address",
        width: 170,
        onHeaderCell: () => ({
          "data-tooltip": "", 
        }),
        render: (text) => {
          return text;
        },
      },
      {
        title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center"}}>
            Trigger
            <ATSToolTip text="Trigger alerts on">
              <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
            </ATSToolTip>
            </span>),
          dataIndex: "trigger",
          key: "trigger",
          width: 50,
          render: (text, record) => <span>{text}</span>,
        },
      // {
      // title: (<span className="font-face-vzw">Latitude</span>),
      //   dataIndex: "latitude",
      //   className: "latitude",
      //   width: 70,
      //   render: (text) => <span className="table-inline-ship-text">{text}</span>,
      //   key: "latitude",
      // },
      // {
      // title: (<span className="font-face-vzw">Longitude</span>),
      //   dataIndex: "longitude",
      //   key: "longitude",
      //   width: 70,
      //   onHeaderCell: () => ({
      //     "data-tooltip": "",
      //   }),
      //   render: (text, record) => <span className="table-inline-ship-text">{text}</span>,
      // },
      // {
      //   title: (<span className="font-face-vzw">Point name</span>),
      //     dataIndex: "name",
      //     key: "name",
      //     width: 70,
      //     onHeaderCell: () => ({
      //       "data-tooltip": "",
      //     }),
      //     render: (text, record) => <span>{text}</span>,
      //   },
        {
          title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center"}}>Radius
            <ATSToolTip text="Geofench radius in meters">
          <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
          </ATSToolTip>
            </span>),
            dataIndex: "radius",
            key: "radius",
            onHeaderCell: () => ({
              "data-tooltip": "",
            }),
            render: (text, record) => <span>{text!==""?text+"m":"None"}</span>,
          },
          {
        title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center"}}>
            Alert Type
            <ATSToolTip text="Severity level of the alarm">
              <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
            </ATSToolTip>
          </span>),
          dataIndex: "alerttype",
          key: "alerttype",
          width: 130,
          onHeaderCell: () => ({
            "data-tooltip": "",
          }),
          render: (text, record) => <span>{text}</span>,
        },
         {
         title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center", width:"130px"}}>
            Alert Group
            <ATSToolTip text="Alert groups to be notified of the alarm">
              <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
            </ATSToolTip>
          </span>),
          dataIndex: "alertgroup",
          key: "alertgroup",
          width: 140,
          onHeaderCell: () => ({
            "data-tooltip": "",
          }),
          render: (text, record) => <span>{text}</span>,
        },
    ]
  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171"
        }}
      >
        Location
      </div>
      <Table 
      dataSource={tableLocationData}
      columns={locationcolumns} 
      pagination={false} />
      {/* <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">Alert Group <img src={CircleIIcon} className="mx-1" alt="info" /></span>
          <div>Not available</div>
        </div>
      </div> */}
    </>
  );
}

export default ShipmentCloneLocations;
